import React from 'react';
import { ItemIdentifier, ItemIndicator } from '../../constants/productObjects';

type ProductIndicatorsProps = {
    itemIdentifier: ItemIdentifier,
    itemIndicators: ItemIndicator[]
    iconSize?: number;
}

export const ProductIndicators = ({ ...props }: ProductIndicatorsProps): JSX.Element => { 
    if (props.itemIndicators === undefined ||
        !props.itemIndicators ||
        !props.itemIndicators.length) {
        return <React.Fragment />;
    }
    return (        
        <div className="wbm-item-indicators">
            {props.itemIndicators
                .filter(
                    (icon) =>
                        icon.itemIdentifier.id === props.itemIdentifier.id &&
                        icon.itemIdentifier.unitId === props.itemIdentifier.unitId
            )
                .sort((a, b) => b.iconPriority - a.iconPriority) 
                .map((indicatorIcon, index) => {
                    let iconSize = 15
                    if (props.iconSize) {
                        iconSize = props.iconSize
                    }
                    return (
                        <img
                            src={indicatorIcon.iconUrl}
                            alt={indicatorIcon.iconAltText}
                            title={indicatorIcon.iconAltText}
                            height={iconSize}
                            width={
                                (indicatorIcon.iconWidth / indicatorIcon.iconHeight) * iconSize
                            }
                            className="wbm-item-indicator"
                            key={props.itemIdentifier.id + props.itemIdentifier.unitId + " indicator: " + index}
                        />
                    );
                })}
        </div>        
    );
}